import f1 from "../assets/F1.png"
import f2 from "../assets/F2.png"
import f3 from "../assets/F3.png"
import f4 from "../assets/F4.png"
import f5 from "../assets/F5.png"
import f6 from "../assets/F6.png"


const frameReducer = (state = {pic: f1, btn: 1}, action) => {
    switch(action.type){
        case "setFrame1":
            return {pic: f1, btn: 1}
        case "setFrame2":
            return {pic: f2, btn: 2}
        case "setFrame3":
            return {pic: f3, btn: 3}
        case "setFrame4":
            return {pic: f4, btn: 4}
        case "setFrame5":
            return {pic: f5, btn: 5}
        case "setFrame6":
            return {pic: f6, btn: 6}
        default:
            return state 
    }
}

export default frameReducer